export default function Footer() {
    return <span>&copy; 2024 ahmetcanisik</span>
}